/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export enum DataState {
  notAsked = 'notAsked',
  loading = 'loading',
  loaded = 'loaded',
  error = 'error',
}
